module.exports = __webpack_public_path__ + "static/media/location-pin.1e573940.svg";